export enum ShareUserRole {
    Reader = 'Reader',
    Contributor = 'Contributor',
}
